import { render, staticRenderFns } from "./Workflow-NeedsAnalysis.vue?vue&type=template&id=1362df96&scoped=true&"
import script from "./Workflow-NeedsAnalysis.vue?vue&type=script&lang=js&"
export * from "./Workflow-NeedsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./Workflow-NeedsAnalysis.vue?vue&type=style&index=0&id=1362df96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362df96",
  null
  
)

export default component.exports